<!-- eslint-disable prettier/prettier -->
<template>
  <div id="clinical-case-consultation" v-loading="isLoading">
    <div class="form">
      <InputGroup>
        <InputWrapper>
          <el-select
            v-model="selectedIndustry"
            placeholder="Patrocinador"
            size="large"
            no-match-text="Nenhuma indústria encontrada"
            filterable
            clearable
          >
            <el-option
              v-for="item in getIndustries"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </InputWrapper>
        <InputWrapper>
          <el-select
            v-model="selectContract"
            placeholder="Contrato Caso Clínico"
            size="large"
            no-match-text="Nenhuma caso clínico encontrato"
            filterable
            clearable
            :disabled="
              !getContractsByIndustryId || getContractsByIndustryId.length === 0
            "
          >
            <el-option
              v-for="item in getContractsByIndustryId"
              :key="item.id"
              :label="item.contractName"
              :value="item.id"
            />
          </el-select>
        </InputWrapper>
        
      </InputGroup>
    </div>
    <div
      class="clinical-case-content"
      :style="{ opacity: contract ? '1' : '0.3' }"
    >
      <InputGroup>
        <InputWrapper>
          <h2>
            <span>Data de Início: </span
            >{{ contract ? resolveDate(contract?.startDate) : '-' }}
          </h2>
        </InputWrapper>
        <InputWrapper>
          <h2>
            <span>Quantidade de casos clínicos: </span
            >{{
              contract ? getTotalVoucher : '-'
            }}
          </h2>
        </InputWrapper>
      </InputGroup>
    </div>
  <InputGroup>
    <InputWrapper>
      <el-input
        v-model="fees"
        :value="fees"
        @input="handleFeesInput"
        type="text"
        min="0"
        placeholder="Honorários Médico Consultor"
        class="flexible-input"
      />
    </InputWrapper>
    <InputWrapper>
      <el-date-picker
        v-model="expirationDate"
        type="date"
        placeholder="Data de Validade"
        format="DD/MM/YYYY"
        size="large"
      />
    </InputWrapper>
    <InputWrapper>
      <el-input
        v-model="quantity" 
        type="number"
        min="0"
        placeholder="Quantidade adicional de casos clínicos"
        class="flexible-input"
      />
    </InputWrapper>
  </InputGroup>
  <InputWrapper style="margin-top: 40px;">
    <h2>
      <span>Quantidade atualizada de casos clínicos: </span
      >{{
         contract ? (Number(getTotalVoucher) + (Number(quantity) || 0)) : '-'
      }}
    </h2>
    <el-switch
    :disabled="!contract"
    v-model="generateLink"
    style="margin-top: 20px;"
    size="large"
    inactive-text="Gerar Link para acesso direto pelo Solicitante:"
  />
    </InputWrapper>
  <div style="width: 100%;">
    <div class="save">
      <el-button type="primary" @click="handleSave" :disabled="!contract"
        >Salvar</el-button
      >
    </div>
  </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import { format, startOfDay, isAfter, isSameDay } from 'date-fns'
import jsPDF from 'jspdf'
import { useToast } from 'vue-toastification'
import { mapActions, mapGetters } from 'vuex'
import 'jspdf-autotable'

import InputGroup from '@/components/inputGroup'
import InputWrapper from '@/components/inputWrapper'
import { formatCurrency } from '@/helpers/currency'
import { formatDate } from '@/helpers/date'
import { formatStatus } from '@/helpers/status'

export default {
  name: 'Atualização Contrato de Caso Clínico',
  components: {
    InputGroup,
    InputWrapper
  },
  setup() {
    const toast = useToast()

    return { toast }
  },
  data() {
    return {
      selectedIndustry: null,
      selectContract: null,
      contract: null,
      quantity: null,
      fees: null,
      expirationDate: null,
      generateLink: false,
      link: ''
    }
  },
  mounted() {
    this.fetchVoucherAll()
    this.fetchIndustries(50)

    this.setIndustryId()
    this.setContractId()
  },
  computed: {
    ...mapGetters('clinicalCaseConsultation', [
      'getIcon',
      'getVouchers',
      'getLoadingVouchers',
      'getTotalPages',
      'getTotalContent',
      'getPage',
      'getIndustry',
      'getContractVoucher',
      'getConsultantDoctor',
      'getStatus',
      'getVoucherHistory',
      'getTotalVoucherAavailable',
      'getTotalVoucher'
    ]),
    ...mapGetters('industry', ['getIndustries', 'getLoadingIndustry']),
    ...mapGetters('contractClinicalCases', [
      'getContractsByIndustryId',
      'getContractLoading',
      'getContract'
    ]),
    ...mapGetters('consultationClinicalCases', [
      'getUsersDoctors',
      'getLoadingContracts'
    ]),

    isLoading() {
      return (
        this.getLoadingIndustry ||
        this.getLoadingContracts ||
        this.getContractLoading ||
        this.getLoadingVouchers
      )
    }
  },
  watch: {
    fees: {
      immediate: true,
      handler(newValue) {
        if (newValue !== null && newValue !== undefined && newValue !== '') {
          // Converte para string
          let stringValue = newValue.toString()

          // Se não tiver ponto nem vírgula, adiciona ",00"
          if (!stringValue.includes('.') && !stringValue.includes(',')) {
            this.fees = stringValue + ',00'
            return
          }

          // Se tiver ponto, converte para vírgula
          if (stringValue.includes('.')) {
            // Verifica se tem casas decimais
            const parts = stringValue.split('.')
            if (parts[1].length === 1) {
              stringValue = stringValue + '0'
            }
            this.fees = stringValue.replace('.', ',')
          }
        }
      }
    },
    generateLink(newValue) {
      if (newValue) {
        this.generateDirectAccessLink()
      } else {
        this.link = ''
      }
    },
    getVouchers() {
      this.tableData = this.getVouchers?.map((voucher) => ({
        voucherId: voucher?.voucherId,
        id: voucher?.id,
        status: formatStatus(voucher?.status),
        date: formatDate(voucher?.updatedAt),
        consultantDoctor: voucher?.consultantDoctorName,
        clientDoctorName: voucher?.clientDoctorName
      }))
    },
    getVoucherHistory() {
      this.tableDataHistoric = this.getVoucherHistory?.map(
        (voucherHistoric) => ({
          status: formatStatus(voucherHistoric?.status),
          date: format(
            new Date(voucherHistoric?.createdAt),
            'dd/MM/yyyy HH:mm:ss'
          ),
          consultantDoctor: voucherHistoric?.name ?? '-'
        })
      )
    },
    getIndustry: 'fetchVoucherAll',
    getContractVoucher: 'fetchVoucherAll',
    getConsultantDoctor: 'fetchVoucherAll',
    getStatus: 'fetchVoucherAll',
    selectedIndustry() {
      this.setIndustryId(this.selectedIndustry)
      this.updatePage(1)

      this.selectContract = null
      this.clearContractsByIndustryId()

      if (!this.selectedIndustry) return

      this.fetchContractByIndustryId(this.selectedIndustry)
    },
    selectContract() {
      if (!this.selectContract) return (this.contract = null)

      this.fetchContract(this.selectContract)
    },
    getContract() {
      if (!this.getContract) return (this.contract = null)

      this.contract = this.getContract[0]
      this.fees = this.contract?.consultantDoctorFees
      this.expirationDate = this.contract?.endDate
      this.generateLink = !!this.contract?.link
      this.link = this.contract?.link || ''
      this.contractId = this.contract?.contractId
      console.log('CONTRACT:', this.contract)
    },
    contract() {
      if (this.contract === null || this.contract === '')
        return this.setContractId()

      this.setContractId(this.contract.contractId)
      this.updatePage(1)
    },
    getPage() {
      this.fetchVoucherAll()
    }
  },
  methods: {
    handleFeesInput(value) {
      // Remove tudo que não for número
      let numericValue = value.replace(/\D/g, '')

      // Se não tiver valor, limpa o campo
      if (!numericValue) {
        this.fees = ''
        return
      }

      // Formata o número enquanto digita
      numericValue = (Number(numericValue) / 100).toFixed(2)

      // Substitui ponto por vírgula
      this.fees = numericValue.replace('.', ',')
    },
    generateDirectAccessLink() {
      if (!this.selectContract || !this.contract) {
        console.error('Nenhum contrato selecionado')
        this.$toast.error('Por favor, selecione um contrato')
        return
      }

      const dataToEncrypt = {
        selectContract: this.selectContract,
        contractId: this.contract.contractId,
        contractName: this.contract.contractName
      }
      console.log('Dados a serem encriptados:', dataToEncrypt)

      const jsonString = JSON.stringify(dataToEncrypt)
      console.log('JSON string:', jsonString)

      const encryptedData = CryptoJS.AES.encrypt(
        jsonString,
        'chave_secreta'
      ).toString()
      console.log('Dados encriptados:', encryptedData)

      const encodedData = encodeURIComponent(encryptedData)
      console.log('Dados codificados para URL:', encodedData)

      this.link = `${window.location.origin}/registration-away/${encodedData}`
      console.log('Link gerado:', this.link)
    },

    ...mapActions('clinicalCaseConsultation', [
      'fetchVoucherAll',
      'updatePage',
      'setIndustryId',
      'setContractId',
      'setConsultantDoctorId',
      'setStatusId',
      'setDateSortOrder',
      'fetchVoucherHistory'
    ]),
    ...mapActions('updateClinicalCase', ['putContract', 'createVouchers']),
    ...mapActions('industry', ['fetchIndustries']),
    ...mapActions('contractClinicalCases', [
      'fetchContractByIndustryId',
      'clearContractsByIndustryId',
      'fetchContract'
    ]),
    ...mapActions('consultationClinicalCases', ['fetchConsultantDoctors']),

    async handleSave() {
      const currentEndDate = new Date(this.contract.endDate)
      const newEndDate =
        this.expirationDate instanceof Date
          ? this.expirationDate
          : new Date(this.expirationDate)

      if (
        !isAfter(startOfDay(newEndDate), startOfDay(currentEndDate)) &&
        !isSameDay(newEndDate, currentEndDate)
      ) {
        this.toast.error(
          'A nova data de validade deve ser igual ou posterior à data atual do contrato.',
          {
            timeout: 8000
          }
        )
        return
      }
      const data = {
        quantity: parseInt(this.quantity) || 0,
        specialtyId: this.contract.specialtyId,
        diseaseId: this.contract.diseaseId,
        industryId: this.contract.industryId,
        startDate: this.contract.startDate,
        endDate: this.expirationDate,
        consultantDoctorFees: parseFloat(this.fees.replace(',', '.')) || 0,
        contractName: this.contract.contractName,
        link: this.generateLink ? this.link : null,
        contractId: this.contract.contractId
      }

      if (
        !data.industryId ||
        !data.specialtyId ||
        !data.diseaseId ||
        !data.contractName ||
        !data.startDate ||
        !data.endDate ||
        !data.consultantDoctorFees
      ) {
        this.toast.warning(
          'Por favor, preencha todos os campos obrigatórios.',
          { timeout: 8000 }
        )
        return
      }

      console.log('DATA:', data)

      try {
        await this.putContract({ data, contractId: this.selectContract })
        await this.createVouchers({ data })
        this.clearForm()
      } catch (error) {
        console.error('Erro ao atualizar o contrato:', error)
        this.toast.error(
          'Não foi possível atualizar o Registro de Caso Clínico',
          { timeout: 8000 }
        )
      }
      this.clearForm()
    },
    clearForm() {
      this.quantity = null
      this.industry = null
      this.startDate = null
      this.expirationDate = null
      this.fees = null
      this.selectedIndustry = null
      this.selectContract = null
      this.generateLink = false
    },

    exportToPDF() {
      const doc = new jsPDF()
      // Adiciona um título
      const title = this.modalHistoricTitle
      doc.setFontSize(14)
      doc.text(title, 14, 22) // (text, x, y)

      // Títulos das colunas
      const headers = [['Status', 'Data', 'Médico Consultor']]

      // Dados da tabela
      const data = this.tableDataHistoric.map((item) => [
        item.status,
        item.date,
        item.consultantDoctor
      ])

      // Adiciona a tabela ao documento PDF
      doc.autoTable({
        head: headers,
        body: data,
        startY: 30
      })

      // Salva o arquivo PDF
      doc.save('table.pdf')
    },

    viewHistory(id, voucherId) {
      this.fetchVoucherHistory(id)
      this.modalHistoricTitle = `ID: ${voucherId}`
      this.isHistoryModalVisible = true
    },

    resolveDate(date) {
      return formatDate(date)
    },

    resolveCurrency(value) {
      return formatCurrency(value)
    },

    handlePageChange(newPage) {
      this.updatePage(newPage)
    },
    sortDate(field) {
      return (a, b) =>
        new Date(a[field]).getTime() - new Date(b[field]).getTime()
    },
    decline(row) {
      this.declineClinicalCase(row.id)
    },
    cancel(row) {
      this.cancelClinicalCase(row.id)
    },
    realoc(row) {
      this.realocClinicalCase(row.id)
    }
  }
}
</script>

<style lang="scss" scoped>
#clinical-case-consultation {
  width: 100%;
  display: block;
  height: fit-content;
  .form {
    flex-direction: column;
    margin-top: 20px;
    display: flex;
    width: 100%;
  }

  .save {
    display: flex;
    width: 150px;
    margin-left: auto;
  }

  .clinical-case-content {
    padding: 12px;

    h2 {
      font-weight: 400;

      span {
        font-weight: 600;
      }
    }
  }

  .clinical-case-table {
    padding: 20px 0;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 19px;
  margin: 2px;

  .action-disabled {
    cursor: not-allowed;
    pointer-events: none;
    color: lightgray;
  }

  svg:hover {
    cursor: pointer;
    transform: translateY(-2px);
    transition: transform 0.2s ease;
  }
}

.title {
  display: flex;
  place-items: flex-end;
  text-align: left;
  color: $green-500;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;

  .voucher-doctor {
    display: flex;
    place-items: flex-end;
    text-align: left;
    color: $green-500;
    width: 100%;
    h1 {
      margin-left: 10px;

      span {
        color: $gray-600;
        font-weight: 400;
      }
    }
  }
}
</style>
